var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1418_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9989 39.4286C31.729 39.4286 40.4275 30.7301 40.4275 20C40.4275 9.26989 31.729 0.571411 20.9989 0.571411C10.2688 0.571411 1.57031 9.26989 1.57031 20C1.57031 30.7301 10.2688 39.4286 20.9989 39.4286Z",
    fill: "#E34506",
    stroke: "#E34506",
    strokeWidth: 1.51429
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1418_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3673 13.0002C22.0561 13.0002 23.6756 13.671 24.8697 14.8652C26.0639 16.0593 26.7347 17.6788 26.7347 19.3676C26.7347 22.0582 24.8441 24.9904 21.1118 28.1956C20.9043 28.3739 20.6397 28.4718 20.3661 28.4716C20.0925 28.4713 19.8281 28.373 19.6209 28.1943L19.374 27.9801C15.807 24.8585 14 21.9981 14 19.3676C14 17.6788 14.6708 16.0593 15.865 14.8652C17.0591 13.671 18.6786 13.0002 20.3673 13.0002ZM20.3673 16.9186C19.7178 16.9186 19.0949 17.1766 18.6357 17.6359C18.1764 18.0951 17.9184 18.718 17.9184 19.3676C17.9184 20.0171 18.1764 20.64 18.6357 21.0992C19.0949 21.5585 19.7178 21.8165 20.3673 21.8165C21.0169 21.8165 21.6398 21.5585 22.099 21.0992C22.5583 20.64 22.8163 20.0171 22.8163 19.3676C22.8163 18.718 22.5583 18.0951 22.099 17.6359C21.6398 17.1766 21.0169 16.9186 20.3673 16.9186Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1418_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 16,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationImg);
export default __webpack_public_path__ + "static/media/location-img.8a219c30b6d4baa766423b33b4e4b5d2.svg";
export { ForwardRef as ReactComponent };